import Button from "../Button";
import {
  useCreateOrderByShopGroup,
  useUpdateVoucher,
} from "../../api/orderBase";
import {
  ConfirmOrderController,
  useConfirmOrderContext,
} from "../../reducer/moduleReducer/confirmOrder";
import { useState } from "react";
import useNotice from "../../hooks/useNotice";
import { useNavigateTo } from "../../hooks/useNavigateTo";
import { useTranslation } from "react-i18next";
import { config } from "../../utils";
import cookies from "../../utils/cookies";
import Dialog from "../Dialog";
import UploadImg from "../uploadImg";

export default function SubmitOrderButton({
  className,
  style,
  text,
  onSuccess,
}) {
  const { loading, submitOrder } = useCreateOrderByShopGroup();
  const { updateVoucherHandle } = useUpdateVoucher();
  const [disabled, setDisabled] = useState(false);
  const { getSubmitOrderQuery } = ConfirmOrderController();
  const { t } = useTranslation();
  const agentInfo = cookies.getAgentInfo();
  const navigateTo = useNavigateTo();
  const notice = useNotice();

  const submit = async () => {
    let query = getSubmitOrderQuery();

    if (!query.addressId && query.transportType === 2) {
      return notice.warn(t("请选择收货地址"));
    }

    if (!query.bookingShopId && query.transportType === 1) {
      return notice.warn(t("请选择自提地址"));
    }

    let { data, error } = await submitOrder(query);

    if (data) {
      let isMul = 0;
      let url = config.PAYMENT_HOST;
      let domain = window.location.hostname;

      if (data.subOrderId && data.subOrderId.split(",").length > 1) {
        isMul = 1;
      }

      let urlQuery = `?orderId=${
        data.orderId
      }&isMulOrder=${isMul}&tk=${cookies.getToken()}&doMainName=${domain}&isFromPC=1`;

      if (query.payType === "1") {
        url += `payment/Stripe.html${urlQuery}`;
        window.open(url, "_blank");
      }

      if (query.payType === "2") {
        url += `payment/Paypal.html${urlQuery}`;
        window.open(url, "_blank");
      }

      if (query.payType === "5" || query.payType === "6") {
        console.log("agentInfo", agentInfo);
        let img_result = "";
        Dialog.qrcode({
          title: query.payType === "5" ? t("PayMe支付") : t("Fps支付"),
          qrcode:
            query.payType === "5" && `${agentInfo.paymeQrUrlView}${urlQuery}`,
          content: query.payType === "6" && agentInfo.fpsTxt,
          showFooter: true,
          onCancel: (onClose) => {
            onClose();
            navigateTo("/orderList");
          },
          onOk: async (onClose) => {
            const q = {
              orderId: data.orderId,
              voucher: img_result,
            };
            const result = await updateVoucherHandle(q);
            console.log("result", result);
            if (result.code === 0) {
              notice.success(t("操作成功"));
              onClose();
              navigateTo("/orderList");
            }
          },
          renderElement: () => (
            <div className="flex justify-center mt-[10px]">
              <UploadImg
                label={t("上传凭证")}
                maxLength={1}
                multiple={false}
                onSuccess={(res) => {
                  img_result = res[0];
                }}
              />
            </div>
          ),
        });
        return;
      }

      if (onSuccess) {
        onSuccess();
      } else {
        notice.success(t("操作成功"));
        setDisabled(true);
        navigateTo("/orderList");
      }
    }
  };
  return (
    <Button
      onClick={submit}
      loading={loading}
      disabled={disabled}
      style={style}
      className={`bg-[#333] text-white py-[8px] w-[300px] py-[8px] rounded-[3px] ${className}`}
    >
      {text ? t(text) : t("提交订单")}
    </Button>
  );
}
